
import { FC, useContext } from "react";

import { SpinProps } from "antd";
import { Spinner } from "../../../../../../../shared/components";

import { GenericDataFormContext } from "../../contexts";

interface SpinnerQuotationProps {
    children: React.ReactNode;
    spinnerProps?: SpinProps;
}

export const SpinnerQuotation: FC<SpinnerQuotationProps> = ({children, spinnerProps}) => {
  const { canShowSpinner } = useContext(GenericDataFormContext);
  return <Spinner spinnerProps={{ spinning: canShowSpinner, ...spinnerProps, }} >{children}</Spinner>
}

